/**
 * Javascript file for the "Not Found" error page.
 * @author Adrian Rebmann, Andrea Villeda
 */

export default {
    name: "NotFound",
  
    /**
     * The vue instance's data object.
     */
    data() {
      return {};
    },
  };


// WEBPACK FOOTER //
// ./src/components/landing/notfound/notfound.js